const genderCd = {
  F: "Female",
  M: "Male",
  NB: "Non-binary",
  O: "Other"
};
export default genderCd;
